import { render, staticRenderFns } from "./RevisionNumbers.vue?vue&type=template&id=42fe0498&scoped=true&"
import script from "./RevisionNumbers.vue?vue&type=script&lang=js&"
export * from "./RevisionNumbers.vue?vue&type=script&lang=js&"
import style0 from "./RevisionNumbers.vue?vue&type=style&index=0&id=42fe0498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fe0498",
  null
  
)

export default component.exports